import React from "react";
import DashboardPage from "./DashboardPage";
import Plans from "./Plans";

const PlansPage = () => {
  return <DashboardPage><Plans/></DashboardPage>;
};

export default PlansPage;
